"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "62",
    height: "62",
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "62",
    height: "62"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#2F61E0"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.5",
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#7F5CF2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "20",
    y: "25",
    width: "51",
    height: "50",
    rx: "6",
    fill: "#7F5CF2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "8",
    y: "11",
    width: "39",
    height: "27",
    rx: "13.5",
    fill: "#0C1E76"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.811 19.5C29.1449 16.9122 26.7958 15 24 15C20.6863 15 18 17.6863 18 21C18 23.1148 19.0941 24.974 20.7471 26.0426C21.4109 26.6379 22.2882 27 23.25 27H24H32.25C34.3211 27 36 25.3211 36 23.25C36 21.1789 34.3211 19.5 32.25 19.5H29.811Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6809 28.8264C22.8239 28.2929 23.3722 27.9763 23.9057 28.1193C24.4391 28.2622 24.7557 28.8105 24.6128 29.344L23.5775 33.2077C23.4346 33.7412 22.8862 34.0577 22.3528 33.9148C21.8193 33.7719 21.5027 33.2235 21.6457 32.6901L22.6809 28.8264ZM30.6809 28.8264C30.8239 28.2929 31.3722 27.9763 31.9057 28.1193C32.4391 28.2622 32.7557 28.8105 32.6128 29.344L31.5775 33.2077C31.4346 33.7412 30.8862 34.0577 30.3528 33.9148C29.8193 33.7719 29.5027 33.2235 29.6457 32.6901L30.6809 28.8264ZM27.9057 28.1193C27.3722 27.9763 26.8239 28.2929 26.6809 28.8264L25.6457 32.6901C25.5027 33.2235 25.8193 33.7719 26.3528 33.9148C26.8862 34.0577 27.4346 33.7412 27.5775 33.2077L28.6128 29.344C28.7557 28.8105 28.4391 28.2622 27.9057 28.1193Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "27",
    y: "42",
    width: "14",
    height: "3",
    rx: "1.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "27",
    y: "49",
    width: "24",
    height: "3",
    rx: "1.5",
    fill: "white"
  })));
}

var _default = Svg;
exports.default = _default;